module.exports = __webpack_public_path__ + "img/lg_ring_r_skip_null_0@3x.9b12c31a.png";